//toggle drawing mode
export const TOGGLE_DRAW = 'TOGGLE_DRAW';

export const toggleDraw = data => {
  return {
    type: TOGGLE_DRAW,
    data
  };
};

export const TOGGLE_DRAW_BUTTONS_VISIBILITY = 'TOGGLE_DRAW_BUTTONS_VISIBILITY';

export const toggleDrawButtonsVisiblity = () => {
  return {
    type: TOGGLE_DRAW_BUTTONS_VISIBILITY
  };
};

//activate drawing module (when disabled - drawn features deisappear)
export const TOGGLE_ACTIVE = 'TOGGLE_ACTIVE';

export const toggleActive = data => {
  return {
    type: TOGGLE_ACTIVE,
    active: data
  };
};

//clear all features
export const CLEAR_DRAW = 'CLEAR_DRAW';
export const clearDraw = data => {
  return {
    type: CLEAR_DRAW,
    data: data
  };
};

//called when features change on the map. 
export const DRAW_FEATURES_CHANGE = 'DRAW_FEATURES_CHANGE';
export const drawFeaturesChange = data => {
  return {
    type: DRAW_FEATURES_CHANGE,
    data: data
  };
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/draw/actions.js